import { motion } from "framer-motion";
import testimonialDavid from "@/assets/landing/testimonial-david.png";
import testimonialPriya from "@/assets/landing/testimonial-priya.png";
import testimonialMarcus from "@/assets/landing/testimonial-marcus.png";

export const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Marcus",
      role: "Food truck owner · Houston, TX",
      avatar: testimonialMarcus,
      quote:
        "I used to check my bank account every morning and just hope the number went up. Now I know exactly where every dollar goes. Last month, Bill flagged that my chicken supplier raised prices 12% — I would have missed that for weeks.",
    },
    {
      name: "Gloria",
      role: "Food hall vendor · Austin, TX",
      avatar: testimonialPriya,
      quote:
        "I'm on three delivery apps and I had no idea which ones were actually making me money. Turns out one of them was costing me more in fees than I was making in profit. I never would have caught that without the platform breakdown.",
    },
    {
      name: "David",
      role: "Owner, neighborhood restaurant · San Antonio, TX",
      avatar: testimonialDavid,
      quote:
        "I used to spend my Sunday nights going through receipts and trying to figure out if I made money that week. Now I check my phone for five minutes on Monday morning and I know. I've never had anything like this.",
    },
  ];

  return (
    <section className="py-24 px-6 bg-stone">
      <div className="container mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-midnight tracking-tight">
            What operators are{" "}
            <span className="text-vault-green">saying.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              whileHover={{ y: -4 }}
              className="bg-white rounded-xl p-8 border border-fog hover:shadow-lg transition-all duration-300 text-center"
            >
              <img
                src={testimonial.avatar}
                alt={testimonial.name}
                className="w-24 h-24 rounded-full object-cover mx-auto mb-6"
                loading="lazy"
              />

              <p className="text-midnight/80 mb-6 leading-relaxed text-sm">
                &ldquo;{testimonial.quote}&rdquo;
              </p>

              <div className="font-semibold text-midnight text-sm">
                {testimonial.name}
              </div>
              <div className="text-xs text-slate-brand mt-0.5">
                {testimonial.role}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
